"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setApiBaseInputs = exports.getApiBaseInputs = void 0;
const getApiBaseInputs = (getItem) => async (aId) => JSON.parse((await getItem(`customBaseInputs:${aId}`)) || '{}');
exports.getApiBaseInputs = getApiBaseInputs;
const setApiBaseInputs = (setItem) => async (appId, newBaseInputs) => {
    await setItem(`customBaseInputs:${appId}`, JSON.stringify(newBaseInputs) || '{}');
};
exports.setApiBaseInputs = setApiBaseInputs;
